import * as React from 'react'
import * as ReactDOM from 'react-dom'
import App from './components/App'
import registerServiceWorker from './registerServiceWorker'

ReactDOM.render(
  <App />, 
  document.getElementById('t-rex') as HTMLElement
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.tsx